import Client from "../client";
import BuiltInFeedStatsResource from "../resources/builtInFeedStatsResource";
import ServerStatusResource from "../resources/serverStatusResource";
import ServerTimezoneResource from "../resources/serverTimezoneResource";
import {ExtensionsInfoResource} from "client/resources/extensionsInfoResource";
import {ActivityLogElement} from "client/resources/taskDetailsResource";
import {SystemInfoResource} from "client/resources/systemInfoResource";
import {ListArgs} from "client/repositories/basicRepository";

interface LogsListArgs extends ListArgs {
    includeDetail: boolean;
}

class ServerStatusRepository {
    private client: Client;
    constructor(client: Client) {
        this.client = client;
    }
    getServerStatus() {
        return this.client.get<ServerStatusResource>(this.client.getRootDocument().Links["ServerStatus"]);
    }
    getLogs(status: ServerStatusResource, args?: LogsListArgs) {
        return this.client.get<ActivityLogElement[]>(status.Links["RecentLogs"], args);
    }
    getSystemInfo(status: ServerStatusResource) {
        return this.client.get<SystemInfoResource>(status.Links["SystemInfo"]);
    }
    getBuiltInFeedStats(status: ServerStatusResource) {
        return this.client.get<BuiltInFeedStatsResource>(status.Links["BuiltInFeedStats"]);
    }
    gcCollect(status: ServerStatusResource) {
        return this.client.post(status.Links["GCCollect"], status);
    }
    getExtensionStats() {
        return this.client.get<ExtensionsInfoResource[]>(this.client.getRootDocument().Links["ExtensionStats"]);
    }
    getTimezones() {
        return this.client.get<ServerTimezoneResource[]>(this.client.getRootDocument().Links["Timezones"]);
    }
}

export default ServerStatusRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/serverStatusRepository.ts